/*
 * UserList Messages
 *
 * This contains all the text for the UserList component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.containers.DepotList.title',
    defaultMessage: 'Depot Management',
  },
  noDepotsYet: {
    id: 'app.containers.DepotList.noDepotsYet',
    defaultMessage: 'There are no depots, yet',
  },
});
